import factory from './icon';
import Svg from './glyphs/search.svg';

export default factory(Svg);
